import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.css";
import "./styles/bootstrap-theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/styles.css";
import "./styles/react-toastify.css";
import "react-widgets/styles.css";

import App from "./App";

// dayjs setup
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
//----

createRoot(document.getElementById("root")!).render(<App />);
